import ProductDescription from './ProductDescription'

const BSCornmealProduct = {
  ...ProductDescription,
  category: '16',
  subCategory: '017',
  IsBroadband: false,
  Size: '',
  FDACert: false,
  Organic: false,
}

export default BSCornmealProduct
